import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@material-ui/core';
import Message from '../../../common/Message';
import { alertMessagePicker } from '../../../../helpers/AlertMessageHelper';
import { useAlertMessageStyles } from './styles';

const AlertMessageList = ({ ...props }) => {
  const { motiveId, mobile } = props;

  const message = alertMessagePicker(motiveId);

  const classes = useAlertMessageStyles({ mobile });

  return (
    <Box className={classes.container}>
      <Message severity="info" mobile={mobile} message={message} fullRounded />
    </Box>
  );
};

AlertMessageList.propTypes = {
  motiveId: PropTypes.string,
  mobile: PropTypes.bool,
};

export default AlertMessageList;
